<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Extraction de la base affiliation avec récupération des NIC dans la base brut</strong>
      </b-card-header>
      <b-card-body>
        <h6>Recherche d'un SIREN</h6>
        <b-row class="mt-3">
          <b-col sm="5">
            <b-form-group
              label-for="siren"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>SIREN</b></template>
              <b-form-input type="text"
                            id="siren"
                            class="custom-input-reduit"
                            v-on:keyup="validateSiren"
                            v-model="siren"
                            :class="{hasError: errors.siren !== ''}">
              </b-form-input>
              <span>(Choisir un SIREN annule le critère Prest'IJ)</span>
              <span class="field-error">{{ errors.siren }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <b-form-group id="form-group-2"
                          :label-cols="3"
                          :horizontal="true">
              <template slot="label"><b>Prest'IJ</b></template>
              <b-form-radio-group class="mt-2" id="radio-group-2" v-model="prestij" name="radio-sub-component">
                <b-form-radio value="false">Non</b-form-radio>
                <b-form-radio value="true">Oui</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {downloadFile, checkSIREN, isEmpty} from '@/utils/fileHelper';

  export default {
    name: "ExtractionAffiliationNic",
    data() {
      return {
        siren: null,
        prestij: 'true',
        errors: {
          siren: '',
        }
      }
    },
    created() {
      // this.$axios.defaults.baseURL = getBaseUrl();
      // this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "text/csv";
      // this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      generateExcel() {
        let self = this;
        let filename = 'extraction_base_affiliation_avec_nic_' + this.getTimestamp()
        const data = {
          siren: this.siren,
          prestij: this.prestij,
        };
        this.$store.commit('IS_LOADING', true);
        if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
          this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
        }
        this.$axios
          .post('/espaceGestion/extractions/base_affiliation_nic', data, {responseType: "arraybuffer"})
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            downloadFile(response, filename, 'csv');
          }).catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              });
      },
      validateSiren: _.debounce(function (event) {
        this.errors.siren = checkSIREN(event.target.value) ? '' : 'saisir un siren valide';
      }, 1000),
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
    }
  }
</script>


